import { render, staticRenderFns } from "./SopQmsRequirementApplicability.vue?vue&type=template&id=288fe537&scoped=true&"
import script from "./SopQmsRequirementApplicability.vue?vue&type=script&lang=ts&"
export * from "./SopQmsRequirementApplicability.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fe537",
  null
  
)

export default component.exports